export const NAVIGATION_ROUTES = {
  HOME: '/dashboard',
  LEARNING_RESOURCES: '/learning-resources',
  ADD_PRODUCT: '/add-product',
  EDIT_PRODUCT: '/edit-product/:editProductId',
  MANAGE_PRODUCT: '/manage-product',
  VIEW_PRODUCT: '/view-product/:viewProductId',
  ADD_ADDONS: '/add-addons',
  EDIT_ADDONS: '/edit-addons/:addonId',
  MANAGE_ADDONS: '/manage-addons',
  VIEW_ADDONS: '/view-addons/:addonId',
  ALL_ORDERS: '/all-orders',
  RETURN_ORDERS: '/return-orders',
  REVIEWS: '/reviews',
  REVIEWS_BY_PRODUCT: '/reviews/:reviewsId',
  VOUCHER_MANAGEMENT: '/voucher-management',
  REPORTS_AND_METRICS: '/reports-and-metrics',
  USER_MANAGEMENT: '/user-management',
  SIGNUP: '/sign-up',
  SIGNIN: '/sign-in',
  LOGIN: '/login',
  EMAILVERIFICATION: '/email-verification',
  PAYMENT_DETAILS: '/payment-details',
  SETPASSWORD: '/set-password',
  IMAGECROPPER: '/image-optimize',
  REGISTRATION: {
    SUCCESS: '/registration-success',
    ERROR: '/registration-error',
  },
  PASSWORD: {
    FORGOT: '/forgot-password',
    RESET: '/reset-password',
  },
  FORGOT_PASSWORD_LINK: '/forgot-password-link',
  RESET_PASSWORD_SUCCESS: '/reset-password-success',
  SETTINGS: '/settings',
  TOC: '/terms-and-conditions',
  UNAUTHORIZED: '/unauthorized',
  DASHBOARD: '/dashboards',
};
